export default __webpack_public_path__ + "static/media/recomend-friend-plan.34d26010.jpg";